/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    checkEmail: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients/check', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getClientsSelect: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/select', {}).then((res) => {
                resolve(res.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteClient: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('clients/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getOrdersClient: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.id + '/orders', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSamplesClient: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.id + '/samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getClients : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getClient : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSelectCountry : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('countries', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSelectState : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('country/' + data.id + '/states', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createClient : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients', data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClient : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('clients/' + data.id, data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ClientsModule.js